import React from 'react';
import { ArrowRight, Star, Clock, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-[#2C1810] text-[#FDF6EC] overflow-hidden" data-id="element-17">
      {/* Background Texture/Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#2C1810] to-[#3E2218] opacity-90" data-id="element-18"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 lg:py-32" data-id="element-19">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-20">
          {/* Text Content */}
          <div className="space-y-8 z-10" data-id="element-21">
            <div className="inline-flex items-center space-x-2 bg-[#F5A623] text-[#2C1810] px-4 py-1.5 rounded-full font-bold text-sm uppercase tracking-wider transform -rotate-1 shadow-lg" data-id="element-22">
              <Star className="w-4 h-4 fill-current" data-id="element-23" />
              <span data-id="element-24">Edición 2026</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white" data-id="element-25">
              <span className="text-[#F5A623]" data-id="element-26">¿Cansada de elegir</span> entre
              comer rico o cerrar el pantalón?
            </h1>

            <p className="font-body text-xl md:text-2xl text-gray-200 leading-relaxed" data-id="element-27">
              El secreto de la despensa en USA: Cómo cenar como latina y bajar
              de peso sin dejar los tacos ni el sabor.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-28">
              <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} className="bg-[#D4522A] hover:bg-[#B8401C] text-white font-heading font-bold text-xl px-8 py-4 rounded-lg shadow-xl transform transition hover:-translate-y-1 hover:shadow-2xl flex items-center justify-center gap-2 border-b-4 border-[#9A3415]" data-id="element-29">
                SÍ, QUIERO MIS CENAS DE 7 MINUTOS
                <ArrowRight className="w-6 h-6" data-id="element-30" />
              </button>
            </div>

            <div className="flex items-center gap-6 text-sm md:text-base text-gray-300 pt-4" data-id="element-31">
              <div className="flex items-center gap-2" data-id="element-32">
                <Clock className="w-5 h-5 text-[#F5A623]" data-id="element-33" />
                <span data-id="element-34">Solo 7 minutos</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-35">
                <CheckCircle2 className="w-5 h-5 text-[#F5A623]" data-id="element-36" />
                <span data-id="element-37">Ingredientes de Walmart/Aldi</span>
              </div>
            </div>
          </div>

          {/* Image Content */}
          <div className="relative z-10 flex justify-center lg:justify-end" data-id="element-38">
            <div className="relative w-full max-w-md lg:max-w-lg transform rotate-2 hover:rotate-0 transition duration-500" data-id="element-39">
              <div className="absolute -inset-4 bg-[#F5A623] rounded-2xl opacity-20 blur-xl animate-pulse" data-id="element-40"></div>
              <img src="https://cdn.magicpatterns.com/uploads/4ZJ836MM59Cx8rdbsRdXwm/mockup_cena-1.png" alt="Cena de 7 Minutos Guía Digital en Tablet y Celular" className="relative w-full h-auto drop-shadow-2xl" data-id="element-41" />

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -left-6 bg-[#FDF6EC] p-4 rounded-xl shadow-xl border-l-4 border-[#D4522A] max-w-[200px]" data-id="element-42">
                <div className="flex text-[#F5A623] mb-1" data-id="element-43">
                  <Star className="w-4 h-4 fill-current" data-id="element-44" />
                  <Star className="w-4 h-4 fill-current" data-id="element-45" />
                  <Star className="w-4 h-4 fill-current" data-id="element-46" />
                  <Star className="w-4 h-4 fill-current" data-id="element-47" />
                  <Star className="w-4 h-4 fill-current" data-id="element-48" />
                </div>
                <p className="text-[#2C1810] font-bold text-sm leading-tight" data-id="element-49">
                  "Bajé 10 libras sin dejar de comer arroz."
                </p>
                <p className="text-gray-500 text-xs mt-1" data-id="element-50">- Maria G.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Wave Separator */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-51">
        <svg className="relative block w-full h-[50px] md:h-[80px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-52">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-[#FDF6EC]" data-id="element-53"></path>
        </svg>
      </div>
    </section>;
}